import script from "./logistic-city-sorting.vue?vue&type=script&setup=true&lang=js"
export * from "./logistic-city-sorting.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__